import { configureStore } from "@reduxjs/toolkit";
import { api } from "./services/api";
import { authReducer, themeReducer, toastReducer } from "./slices";
import { publicApi } from "./services/public";

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [publicApi.reducerPath]: publicApi.reducer,
    auth: authReducer,
    toast: toastReducer,
    theme: themeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware).concat(publicApi.middleware),
});

export type Rootstate = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
